<template>
  <div class="set-material-column">
    <el-form ref="form" :model="form" :rules="rules">
      <el-table :data="form.table">
        <el-table-column
          label="序号"
          prop="index"
          align="center"
          type="index"
          width="80"
        />
        <el-table-column
          label="字段名称"
          prop="columnName"
          align="left"
          header-align="center"
        >
          <template slot-scope="{ row, $index }">
            <el-form-item
              v-if="row.canEditColumnName"
              :prop="'table.' + $index + '.columnName'"
              :rules="rules.columnName"
            >
              <el-input
                v-model="row.columnName"
                placeholder="请输入"
                maxlength="10"
              />
            </el-form-item>
            <span v-else>{{ row.columnName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="字段类型" prop="defineType" align="center">
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'table.' + $index + '.defineType'"
              :rules="rules.defineType"
            >
              <el-select
                v-model="row.defineType"
                style="width: 100%"
                placeholder="请选择"
                :disabled="defineTypeDisabled(row)"
                @change="handleKeyTypeChange(row)"
              >
                <el-option
                  v-if="
                    row.defineType ===
                      materialTemplateDefineTypeDict.SYSTEM.value
                  "
                  :value="materialTemplateDefineTypeDict.SYSTEM.value"
                  :label="materialTemplateDefineTypeDict.SYSTEM.label"
                />
                <el-option
                  v-for="item in keyTypeOption"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="供应商是否必填"
          prop="supplierRequire"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form-item>
              <el-select
                v-model="row.supplierRequire"
                style="width: 100%"
                placeholder="请选择"
                :disabled="!row.canEditSupplierRequire"
              >
                <el-option
                  v-if="!row.canEditSupplierRequire"
                  value=""
                  label="-"
                />
                <el-option
                  v-for="item in materialTemplateKeySupplierRequireDict.array"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="供应商是否可见"
          prop="supplierVisible"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form-item>
              <el-select
                v-model="row.supplierVisible"
                style="width: 100%"
                placeholder="请选择"
                :disabled="!row.canEditSupplierVisible"
              >
                <el-option
                  v-if="!row.canEditSupplierVisible"
                  value=""
                  label="-"
                />
                <el-option
                  v-for="item in materialTemplateKeySupplierVisibleDict.array"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" prop="enable" align="center">
          <template slot-scope="{ row }">
            <el-form-item>
              <a-switch
                v-model="row.enable"
                checked-children="开"
                un-checked-children="关"
                default-checked
                :disabled="!row.canEditEnable"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row, $index }">
            <a-button
              v-if="
                row.defineType !== materialTemplateDefineTypeDict.SYSTEM.value
              "
              class="text-danger"
              type="link"
              @click="removeKey($index)"
            >
              删除
            </a-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="add-button" @click="addRow">
      <i class="el-icon-plus"></i>
      新增字段列（{{ form.table.length - 6 }}/{{ maxNum }}）
    </div>
  </div>
</template>

<script>
import {
  materialColumnTypeDict,
  materialTemplateBelongDict,
  materialTemplateKeyStatusDict,
  materialTemplateKeySupplierRequireDict,
  materialTemplateKeySupplierVisibleDict,
  materialTemplateDefineTypeDict
} from '@/dictionary/material/template'
import { cloneDeep } from 'lodash'

const historyCode = [
  'materielBrand',
  'deliveryAddress',
  'deliveryDay',
  'offerMaterielModel',
  'offerMaterielBrand',
  'offerDeliveryDay',
  'itemBrand',
  'offerItemModel',
  'offerItemBrand'
]

/**
 * @description 采购清单字段列设置
 */
export default {
  name: 'SetMaterialColumn',

  props: {
    column: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      materialTemplateBelongDict,
      materialTemplateDefineTypeDict,
      materialTemplateKeySupplierRequireDict,
      materialTemplateKeySupplierVisibleDict,
      materialTemplateKeyStatusDict,

      maxNum: 30,

      form: {
        // 字段列表
        table: [
          {
            columnName: '品目名称',
            canEditColumnName: true,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.YES.value,
            enable: true,
            canEditEnable: false,
            columnType: materialColumnTypeDict.NAME.value
          },
          {
            columnName: '编码',
            canEditColumnName: false,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.NO.value,
            enable: true,
            canEditEnable: false,
            columnType: materialColumnTypeDict.CODE.value
          },
          {
            columnName: '数量',
            canEditColumnName: false,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.YES.value,
            enable: true,
            canEditEnable: false,
            columnType: materialColumnTypeDict.NUM.value
          },
          {
            columnName: '单位',
            canEditColumnName: false,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.YES.value,
            enable: true,
            canEditEnable: false,
            columnType: materialColumnTypeDict.UNIT.value
          },
          {
            columnName: '预算单价（元）',
            canEditColumnName: false,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.NO.value,
            enable: true,
            canEditEnable: false,
            columnType: materialColumnTypeDict.UNIT_PRICE.value
          },
          {
            columnName: '控制价',
            canEditColumnName: false,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.YES.value,
            enable: false,
            canEditEnable: true,
            columnType: materialColumnTypeDict.CONTROL_PRICE.value
          },
          {
            columnName: '参数型号',
            canEditColumnName: false,
            defineType: materialTemplateDefineTypeDict.SYSTEM.value,
            supplierRequire: '',
            supplierVisible: materialTemplateKeySupplierVisibleDict.YES.value,
            canEditSupplierVisible: true,
            enable: true,
            canEditEnable: true,
            columnType: materialColumnTypeDict.MODEL.value
          }
        ]
      },
      rules: {
        columnName: { required: true, message: '请输入', trigger: 'blur' },
        defineType: {
          required: true,
          message: '请选择',
          trigger: ['blur', 'change']
        }
      }
    }
  },

  computed: {
    keyTypeOption() {
      const { SPECIFY, RESPONSE } = materialTemplateDefineTypeDict
      return [SPECIFY, RESPONSE]
    }
  },

  watch: {
    column: {
      handler(val) {
        if (val.length) {
          this.setFormTable(val)
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    /**
     * 根据外部传入的配置定义字段列表
     */
    setFormTable(column) {
      const array = cloneDeep(column)
      this.form.table = array.map(item => {
        // 仅品目名称和非系统创建的字段可以修改名称
        // 历史字段对应的名称不可修改
        const isHistoryCode = historyCode.includes(item.defineCode)
        if (
          (item.columnType === materialColumnTypeDict.NAME.value ||
            item.defineType !== materialTemplateDefineTypeDict.SYSTEM.value) &&
          !isHistoryCode
        ) {
          item.canEditColumnName = true
        } else {
          item.canEditColumnName = false
        }
        // 针对自定义字段做处理
        if (item.columnType === materialColumnTypeDict.CUSTOM.value) {
          // 如果是采购人指定，则禁选供应商是否必填
          if (
            item.defineType === materialTemplateDefineTypeDict.SPECIFY.value
          ) {
            item.canEditSupplierVisible = true
            item.canEditSupplierRequire = false
          }
          // 如果是供应商响应，则禁选供应商是否可见
          if (
            item.defineType === materialTemplateDefineTypeDict.RESPONSE.value
          ) {
            item.canEditSupplierVisible = false
            item.canEditSupplierRequire = true
          }
        }

        return item
      })
    },

    /**
     * 添加一行
     */
    addRow() {
      if (this.form.table.length - 6 >= this.maxNum) {
        this.$message.info('已达上限')
        return
      }
      this.form.table.push({
        columnName: '',
        canEditColumnName: true,
        defineType: '',
        supplierRequire: '',
        canEditSupplierRequire: true,
        supplierVisible: '',
        canEditSupplierVisible: true,
        enable: true,
        canEditEnable: true,
        columnType: materialColumnTypeDict.CUSTOM.value
      })
    },

    /**
     * 当前字段类型切换
     */
    handleKeyTypeChange(row) {
      // 如果选择采购人指定，则禁选供应商是否必填
      if (row.defineType === materialTemplateDefineTypeDict.SPECIFY.value) {
        row.canEditSupplierVisible = true
        row.canEditSupplierRequire = false
        row.supplierRequire = ''
        row.supplierVisible = materialTemplateKeySupplierVisibleDict.YES.value
        return
      }
      // 如果选择供应商响应，则禁选供应商是否可见
      if (row.defineType === materialTemplateDefineTypeDict.RESPONSE.value) {
        row.canEditSupplierVisible = false
        row.canEditSupplierRequire = true
        row.supplierRequire = materialTemplateKeySupplierRequireDict.YES.value
        row.supplierVisible = ''
        return
      }
    },

    /**
     * 删除当前字段行
     */
    removeKey(index) {
      this.form.table.splice(index, 1)
    },

    /**
     * 表单校验
     */
    formValid() {
      return this.$refs.form.validate()
    },

    /**
     * 同步父组件中的数据
     */
    updateColumn() {
      // 需要根据自定义的字段定义类型，指定defineCode
      // 如果是采购人指定，则defineCode为expand+序号
      // 如果是供应商响应，则defineCode为offerExpand+序号
      // 序号必须按照各自的添加顺序有序递增
      let specifyIndex = 0
      let responseIndex = 0
      this.form.table.forEach(item => {
        item.isEnable = item.enable ? 1 : 0
        if (
          item.defineCode &&
          !item.defineCode.includes('expand') &&
          !item.defineCode.includes('offerExpand')
        ) {
          return
        }
        if (item.defineType === materialTemplateDefineTypeDict.SPECIFY.value) {
          specifyIndex++
          item.defineCode = 'expand' + specifyIndex
          return
        }
        if (item.defineType === materialTemplateDefineTypeDict.RESPONSE.value) {
          responseIndex++
          item.defineCode = 'offerExpand' + responseIndex
        }
      })
      return this.form.table
      // this.$emit('update:column', this.form.table)
    },

    defineTypeDisabled(row) {
      // 系统字段不可更改
      const isSystemType =
        row.defineType === materialTemplateDefineTypeDict.SYSTEM.value
      // defineCode为materielBrand、deliveryAddress、deliveryDay和offerMaterielModel等历史字段也不可修改
      const isHistoryCode = historyCode.includes(row.defineCode)
      return isSystemType || isHistoryCode
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form {
  .el-form-item {
    width: 100%;
    display: flex;

    .el-form-item__content {
      flex: 1;
    }
  }
}

::v-deep .el-table .cell {
  padding: 0 24px;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: $info-fifth-color;
  border-color: $info-third-color;
  color: $third-text-color;
}

::v-deep .el-form-item--small.el-form-item {
  margin-top: 18px;
}

.add-button {
  width: 100%;
  margin-top: 16px;
  border: 1px dashed $primary-color;
  color: $primary-color;
  text-align: center;
  padding: 6px 0;
  border-radius: 4px;
  cursor: pointer;
}
</style>
